<script>
import Layout from "../../../layouts/main.vue";
import PageHeader from "@/components/page-header.vue";
import { KanbanComponent, ColumnDirective, ColumnsDirective } from "@syncfusion/ej2-vue-kanban";
import { addClass } from "@syncfusion/ej2-base";
import { createApp } from "vue";
import cardTemplate from "./overview-card-template.vue";
import columnTemplate from "./overview-column-template.vue";
import api from "@/axios";
import Loader from "@/router/views_mobagile/components/loader.vue";
import Swal from "sweetalert2";
import moment from "moment/moment";
import {DxButton} from "devextreme-vue/button";
import DxTextBox from "devextreme-vue/text-box";
import DxToolbar, {DxItem} from "devextreme-vue/toolbar";
import {getBaseUrl} from "@/helpers/baseUrl";
import { Workbook } from 'exceljs';
import { saveAs } from 'file-saver-es';


export default {

  components: {
    DxToolbar, DxItem, DxButton, DxTextBox,
    Loader,
    Layout,
    PageHeader,
    'ejs-kanban': KanbanComponent,
    'e-column': ColumnDirective,
    'e-columns': ColumnsDirective
  },

  data() {
    return {
      title: "Leads",
      items: [
        {
          text: "Pessoas",
          href: "/",
        },
        {
          text: "Leads",
          active: true,
        },
      ],
      cardSettings: {
        headerField: "nome",
        template: function() {
          return { template: createApp({}).component('cardTemplate', cardTemplate) };
        },
        selectionType: "Multiple"
      },
      swimlaneSettings: {
        keyField: "acomp"
      },
      columnsTemplate: function() {
        return { template: createApp({}).component('cardTemplate', columnTemplate) };
      },
      leadsData: null,
      leadsSemFiltroData: null,
      loading: true,
      leadData: {},
      showModalLead: false,
      submittedLead: false,
      visibleLead: true,
      visibleCliente: false,
      visibleInteracoes: true,
      submittedInterac: false,
      interacsData: null,
      interacData: {},
      novaInterac: false,
      loadingInteracs: false,
      dtIniFiltro: null,
      dtFimFiltro: null,
      showModalPeriodo: false,
      submittedPeriodo: false,
      erroPeriodo: '',
      errosValid: null,
      showModalUpload: false,
      uploadProgress: '',
      showModalConfirmUpload: false,
      fileToUpload: null,
      showModalInstrucoes: false,

    };
  },

  mounted() {
    console.log('mounted_leads')
    this.atualizaDataList()
  },


  methods: {

    resetModalState(){
      console.log('resetModalState')
      this.novaInterac = false
      this.visibleInteracoes = true
      this.visibleLead = true
      this.visibleCliente = false
      this.submittedInterac = false
      this.submittedLead = false
      this.interacData = {}
    },

    pesquisar(evt){
      console.log('pesquisar')
      const textPesq = evt.event.target.value
      // console.log(textPesq)
      if (textPesq.length === 0){
        this.leadsData = this.leadsSemFiltroData
      } else {
        let listFiltrada = []
        this.leadsSemFiltroData.forEach(lead => {
          if (lead.nome.toLowerCase().includes(textPesq.toLowerCase())
              || lead.cnpj.toLowerCase().includes(textPesq.toLowerCase())
              || (lead.resumo && lead.resumo.toLowerCase().includes(textPesq.toLowerCase()))) {
            listFiltrada.push(lead)
          }
        })
        this.leadsData = listFiltrada
      }
    },

    criarLead(){
      console.log('criarLead')
      this.leadData = {
        'status': 'AB',
        'prior': 'NM',
        'pontos': 0
      }
      this.interacsData = null
      this.visibleLead = true
      this.visibleInteracoes = false
      this.novaInterac = false
      this.showModalLead = true
      this.visibleCliente = true
      this.errosValid = null
      this.submittedLead = false
    },

    confirmarPeriodo(){
      console.log('confirmarPeriodo')
      let difDias = moment(this.dtFimFiltro).diff(moment(this.dtIniFiltro), 'days')
      console.log(difDias)
      if (difDias < 31) {
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': moment(this.dtIniFiltro).format('YYYY-MM-DD'),
          'movdf': moment(this.dtFimFiltro).format('YYYY-MM-DD'),
        }))
        this.showModalPeriodo = false
        this.atualizaDataList()
      } else {
        this.erroPeriodo = 'Diferença entre data inicial e final deve ser menor que 31 dias, caso necessário um período maior favor entrar em contato com suporte.'
      }
    },

    editarInterac(interac){
      console.log('editarInterac')
      this.visibleLead = false
      this.novaInterac = true
      this.interacData = interac
    },

    deletarInterac(interacId){
      console.log('deletaInterac')
      // this.showModalLead = false
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: 'Atenção!',
        text: `Deseja realmente excluir a Interação ID ${interacId}? Essa ação não pode ser desfeita!`,
        showConfirmButton: true,
        confirmButtonText: 'Confirmar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar'
      }).then((selected) => {
        if(selected.isConfirmed){
          this.loadingInteracs = true
          api.delete(`${getBaseUrl()}api/leadinterac`,  {
            params: {
              iddata: interacId
            }
          }).then((res) => {
            console.log(res)
            Swal.fire({
              position: 'top-end',
              title: 'Sucesso',
              icon: 'success',
              text: 'Registro deletado com sucesso!',
              timer: 1000,
              showCancelButton: false,
              showConfirmButton: false,
            }).then(() => {
              this.carregaInteracs()
            });
          })
        }
      })
    },

    carregaInteracs(){
      console.log('carregaInteracs')
      this.loadingInteracs = true
      api.get(`${getBaseUrl()}api/interacs`, {
        params: {'leadId': this.leadData.id},
      }).then(response => {
        console.log('response.data_0')
        console.log(response.data)
        this.interacsData = response.data[0]
        this.loadingInteracs = false
      })
    },

    confInterac(){
      console.log('confInterac')
      this.submittedInterac = true
      this.loadingInteracs = true
      this.interacData.lead_id = this.leadData.id
      api.post(`${getBaseUrl()}api/leadinterac`, {
        interacData: this.interacData
      }).then((res) => {
        console.log('then axios')
        console.log(res)
        this.novaInterac = false
        this.carregaInteracs()
      }).catch((err) => {
        console.error('Erro ao salvar interação:', err)
        Swal.fire({
          position: 'top-end',
          icon: 'error',
          title: 'Erro',
          text: err.response?.data?.errors || 'Erro ao salvar interação',
          timer: 3000,
        })
        this.loadingInteracs = false
      })
    },

    novaInteracao(){
      console.log('novaInteracao')
      this.interacData = {
        contato: '',
        cargo: '',
        canal: 'OT',
        telefone: '',
        email: '',
        obs: ''
      }
      this.submittedInterac = false
      this.visibleLead = false
      this.visibleCliente = false
      this.visibleInteracoes = true
      this.novaInterac = true
    },

    deletaLead() {
      console.log('deletaLead')
      this.showModalLead = false
      Swal.fire({
        position: 'center',
        icon: 'info',
        title: 'Atenção!',
        text: `Deseja realmente excluir o Lead ID ${this.leadData.id}? Essa ação não pode ser desfeita!`,
        showConfirmButton: true,
        confirmButtonText: 'Confirmar',
        showCancelButton: true,
        cancelButtonText: 'Cancelar'
      }).then((selected) => {
        if(selected.isConfirmed){
          this.loading = true
          api.delete(`${getBaseUrl()}api/lead`,  {
            params: {
              iddata: this.leadData.id
            }
          }).then((res) => {
            Swal.fire({
              position: 'top-end',
              title: 'Sucesso',
              icon: 'success',
              text: 'Registro deletado com sucesso!',
              timer: 1000,
              showCancelButton: false,
              showConfirmButton: false,
            }).then(() => {
              this.leadsData = res.data[0]
              this.leadsSemFiltroData = res.data[0]
              this.loading = false
            });
          })
        }
      })
    },

    confLead(){
      console.log('confLead')
      this.submittedLead = true
      if (this.leadData.acomp && this.leadData.status && this.leadData.prior && this.leadData.cnpj && this.leadData.nome) {
        this.showModalLead = false
        this.loading = true
        api.post(`${getBaseUrl()}api/lead`, {
          leadData: this.leadData
        }).then((res) => {
          console.log('then axios')
          console.log(res)
          this.leadsData = res.data[0]
          this.leadsSemFiltroData = res.data[0]
          this.loading = false
        }).catch((err) => {
          console.log('erro axios')
          // console.log(err)
          // console.log(err.response)
          // console.log(err.response.data.errors)
          let erros = err.response.data.errors
          console.log(erros)
          console.log(typeof  erros)
          let listaErros = []
          Object.keys(erros).forEach(key => {
            console.log(key, erros[key]);
            listaErros.push({
              'titulo': key,
              'mensagem': erros[key]
            })
          });
          this.errosValid = listaErros
          this.loading = false
        })
      }
    },

    atualizaDataList(){
      console.log('atualizaDataList_leads')
      this.loading = true
      const filtros = JSON.parse(localStorage.getItem("filtros"))
      if (!filtros) {
        let perIniPadrao = moment(new Date()).startOf('month').format('YYYY-MM-DD')
        let perFimPadrao = moment(new Date()).endOf('month').format('YYYY-MM-DD')
        this.dtIniFiltro = perIniPadrao
        this.dtFimFiltro = perFimPadrao
        localStorage.setItem('filtros', JSON.stringify({
          'movdi': perIniPadrao,
          'movdf': perFimPadrao,
        }))
      } else {
        this.dtIniFiltro = filtros['movdi']
        this.dtFimFiltro = filtros['movdf']
      }
      const paramsReq = {
        'di': this.dtIniFiltro,
        'df': this.dtFimFiltro,
      }
      api.get(`${getBaseUrl()}api/leads`, {
        params: paramsReq,
      }).then(response => {
        console.log('response.data_0')
        console.log(response.data[0])
        this.leadsData = response.data[0]
        this.leadsSemFiltroData = response.data[0]
        this.loading = false
        const dtIniFormated = moment(this.dtIniFiltro).format('DD/MM/YYYY')
        const dtFimFormated = moment(this.dtFimFiltro).format('DD/MM/YYYY')
        this.title = `(${this.leadsData.length}) Leads: ${dtIniFormated} - ${dtFimFormated}`
      })
    },

    dialogOpen: function (args) {
      console.log('dialogOpen')
      console.log(args)
      this.leadData = args.data
      args.cancel = true
      this.resetModalState()
      this.showModalLead = true
      this.carregaInteracs()
    },

    cardRendered: function (args) {
      let val = args.data.prior;
      addClass([args.element], val);
    },

    formatDateTime(value) {
      // console.log('value formatDate')
      // console.log(value)
      // console.log(moment())
      const format = "DD/MM/YYYY HH:mm:ss"
      var date = new Date(value);
      let dateTime = moment(date).format(format);
      // console.log(dateTime1)
      return dateTime
    },

    downloadExemplo() {
      console.log('downloadExemplo')
      this.showModalInstrucoes = true;
    },

    confirmarDownload() {
      console.log('confirmarDownload')
      this.showModalInstrucoes = false;

      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet('Leads');
      worksheet.columns = [
        { header: 'acomp', key: 'acomp', width: 20 },
        { header: 'status', key: 'status', width: 15 },
        { header: 'prior', key: 'prior', width: 15 },
        { header: 'cnpj', key: 'cnpj', width: 20 },
        { header: 'nome', key: 'nome', width: 40 },
        { header: 'fantasia', key: 'fantasia', width: 30 },
        { header: 'pontos', key: 'pontos', width: 10 },
        { header: 'resumo', key: 'resumo', width: 50 },
        { header: 'endereco', key: 'endereco', width: 40 },
        { header: 'bairro', key: 'bairro', width: 30 },
        { header: 'cidade', key: 'cidade', width: 30 },
        { header: 'estado', key: 'estado', width: 10 },
        { header: 'email', key: 'email', width: 30 },
        { header: 'tel1', key: 'tel1', width: 20 },
        { header: 'tel2', key: 'tel2', width: 20 },
        { header: 'tel3', key: 'tel3', width: 20 },
        { header: 'contato', key: 'contato', width: 30 },
        { header: 'cargo', key: 'cargo', width: 20 },
        { header: 'obs', key: 'obs', width: 50 },
        { header: 'telefone', key: 'telefone', width: 20 },
        { header: 'canal', key: 'canal', width: 15 },
      ];
      worksheet.addRow({
        acomp: 'João Silva (Obrigatório)',
        status: 'AB (se não preenchido fica como AB)',
        prior: 'BX (se não preenchido fica como BX)',
        cnpj: '12345678000190 (Obrigatório e sem repetição)',
        nome: 'Empresa Exemplo LTDA (Obrigatório)',
        fantasia: 'Exemplo',
        pontos: 10,
        resumo: 'Lead de exemplo',
        endereco: 'Rua Exemplo, 123',
        bairro: 'Centro',
        cidade: 'São Paulo',
        estado: 'SP',
        email: 'contato@exemplo.com',
        tel1: '11999999999',
        tel2: '1133333333',
        tel3: '',
        contato: 'Maria Silva (Obrigatório)',
        cargo: 'Gerente',
        obs: 'Primeira interação com cliente',
        telefone: '11988888888',
        canal: 'TL (padrão se não preenchido)'
      });
      workbook.xlsx.writeBuffer().then(buffer => {
        saveAs(new Blob([buffer]), 'exemplo_leads.xlsx');
      });
    },

    uploadExcel(event) {
      console.log('uploadExcel')
      const file = event.target.files[0];
      if (!file) return;

      this.fileToUpload = file;
      this.showModalConfirmUpload = true;
    },

    async confirmarUpload() {
      console.log('confirmarUpload')
      if (!this.fileToUpload) return;

      this.showModalConfirmUpload = false;
      this.loading = true;
      this.showModalUpload = true;
      this.uploadProgress = 'Processando planilha...';

      try {
        const workbook = new Workbook();
        const buffer = await this.fileToUpload.arrayBuffer();
        await workbook.xlsx.load(buffer);
        const worksheet = workbook.getWorksheet(1);
        const jsonData = [];

        worksheet.eachRow((row, rowNumber) => {
          if (rowNumber > 1) {
            const cnpjValue = row.getCell(4).value;
            const nomeValue = row.getCell(5).value;
            const contatoValue = row.getCell(17).value;

            const isEmptyRow = !cnpjValue && !nomeValue && !contatoValue;
            if (isEmptyRow) {
              return;
            }

            jsonData.push({
              cnpj: cnpjValue === null || cnpjValue === undefined ? '0' : cnpjValue.toString(),
              acomp: row.getCell(1).value || '',
              status: row.getCell(2).value || 'AB',
              prior: row.getCell(3).value || 'BX',
              nome: nomeValue || '',
              fantasia: row.getCell(6).value || '',
              pontos: row.getCell(7).value || 0,
              resumo: row.getCell(8).value || '',
              endereco: row.getCell(9).value || '',
              bairro: row.getCell(10).value || '',
              cidade: row.getCell(11).value || '',
              estado: row.getCell(12).value || '',
              email: row.getCell(13).value || '',
              tel1: row.getCell(14).value || '',
              tel2: row.getCell(15).value || '',
              tel3: row.getCell(16).value || '',
              contato: contatoValue || '',
              cargo: row.getCell(18).value || '',
              obs: row.getCell(19).value || '',
              telefone: row.getCell(20).value || '',
              canal: row.getCell(21).value || 'OT',
            });
          }
        });

        let successCount = 0;
        let errorCount = 0;
        const errors = [];

        for (let i = 0; i < jsonData.length; i++) {
          const itemData = jsonData[i];
          this.uploadProgress = `Enviando item ${i + 1} de ${jsonData.length}...`;

          try {
            await api.post(`${getBaseUrl()}api/dinamicinterac`, itemData);
            successCount++;
          } catch (err) {
            errorCount++;
            errors.push({
              linha: i + 2,
              nome: itemData.nome,
              erro: err.response?.data?.errors || err.response?.data?.message || 'Erro ao salvar lead'
            });
          }
        }

        this.showModalUpload = false;
        this.fileToUpload = null;

        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.value = '';
        }

        this.atualizaDataList();

        if (errorCount === 0) {
          Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Sucesso!',
            text: `${successCount} Interações importadas com sucesso!`,
            showConfirmButton: true,
          });
        } else {
          let errorHtml = `
            <div style="text-align: left;">
              <p style="text-align: center; margin-bottom: 20px;">
                <strong style="color: #28a745;">${successCount} Interações importadas com sucesso</strong><br>
                <strong style="color: #dc3545;">${errorCount} erro(s) encontrado(s)</strong>
              </p>
              <div style="max-height: 400px; overflow-y: auto;">
                <table style="width: 100%; border-collapse: collapse; font-size: 14px;">
                  <thead>
                    <tr style="background-color: #f8f9fa; border-bottom: 2px solid #dee2e6;">
                      <th style="padding: 10px; text-align: left; border: 1px solid #dee2e6; width: 60px;">Linha</th>
                      <th style="padding: 10px; text-align: left; border: 1px solid #dee2e6;">Nome</th>
                      <th style="padding: 10px; text-align: left; border: 1px solid #dee2e6;">Erro</th>
                    </tr>
                  </thead>
                  <tbody>
          `;

          errors.forEach((err, index) => {
            const bgColor = index % 2 === 0 ? '#ffffff' : '#f8f9fa';
            errorHtml += `
              <tr style="background-color: ${bgColor}; border-bottom: 1px solid #dee2e6;">
                <td style="padding: 8px; border: 1px solid #dee2e6; text-align: center;"><strong>${err.linha}</strong></td>
                <td style="padding: 8px; border: 1px solid #dee2e6;">${err.nome || 'N/A'}</td>
                <td style="padding: 8px; border: 1px solid #dee2e6; color: #dc3545;">${err.erro}</td>
              </tr>
            `;
          });

          errorHtml += `
                  </tbody>
                </table>
              </div>
            </div>
          `;

          Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'Importação concluída com avisos',
            html: errorHtml,
            showConfirmButton: true,
            width: '800px',
            customClass: {
              popup: 'swal-wide'
            }
          });
        }
      } catch (e) {
        console.error(e);
        this.showModalUpload = false;
        this.fileToUpload = null;

        const fileInput = document.querySelector('input[type="file"]');
        if (fileInput) {
          fileInput.value = '';
        }

        Swal.fire({
          position: 'center',
          icon: 'error',
          title: 'Erro',
          text: 'Falha na importação do arquivo Excel.',
          showConfirmButton: true,
        });
      } finally {
        this.loading = false;
      }
    },

    cancelarUpload() {
      console.log('cancelarUpload')
      this.showModalConfirmUpload = false;
      this.fileToUpload = null;

      const fileInput = document.querySelector('input[type="file"]');
      if (fileInput) {
        fileInput.value = '';
      }
    },

    async buscarDadosPessoa() {
      console.log('buscarDadosPessoa')

      if (!this.leadData.cnpj) {
        Swal.fire({
          position: 'center',
          icon: 'warning',
          title: 'Atenção!',
          text: 'Por favor, informe o CNPJ antes de buscar os dados.',
          showConfirmButton: true,
        });
        return;
      }

      this.loading = true;

      try {
        const response = await api.get(`${getBaseUrl()}api/fillleaddetails`, {
          params: { cnpj: this.leadData.cnpj }
        });

        if (response.data && response.data.data) {
          const dados = response.data.data;

          this.leadData.cnpj = dados.cnpj || this.leadData.cnpj;
          this.leadData.nome = dados.nome || '';
          this.leadData.fantasia = dados.fantasia || '';
          this.leadData.endereco = dados.endereco || '';
          this.leadData.bairro = dados.bairro || '';
          this.leadData.cidade = dados.cidade || '';
          this.leadData.estado = dados.estado || '';
          this.leadData.email = dados.email || '';
          this.leadData.tel1 = dados.tel1 || '';
          this.leadData.tel2 = dados.tel2 || '';
          this.leadData.tel3 = dados.tel3 || '';

          Swal.fire({
            position: 'top-end',
            icon: 'success',
            title: 'Sucesso!',
            text: 'Dados preenchidos automaticamente.',
            timer: 2000,
            showConfirmButton: false,
          });
        }
      } catch (err) {
        console.error(err);

        if (err.response?.status === 404) {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'CNPJ não encontrado!',
            text: 'Não foi encontrado nenhum cadastro com este CNPJ na lista de pessoas.',
            showConfirmButton: true,
          });
        } else {
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Erro!',
            text: err.response?.data?.message || 'Erro ao buscar dados da pessoa.',
            showConfirmButton: true,
          });
        }
      } finally {
        this.loading = false;
      }
    },

  },

};

</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" @click="showModalPeriodo = true; erroPeriodo = ''"/>

    <b-alert v-for="(erro, i) in errosValid" :key="`alerta-${i}`"   show dismissible variant="danger" >
      <i class="mdi mdi-alert me-2"></i>Pendente validação de campo: {{ erro.titulo }} -- {{ erro.mensagem[0] }} --
      favor ajustar e tentar novamente.
    </b-alert>

    <Loader v-if="loading" style="min-height: 300px;">
    </Loader>

    <div class="row" v-if="!loading">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <DxToolbar>
              <DxItem
                  location="before">
                <DxButton
                    icon="plus"
                    hint="Criar novo lead"
                    text="Novo Lead"
                    :on-click="criarLead"/>
              </DxItem>
              <DxItem
                  location="before">
                <DxButton
                    icon="download"
                    hint="Baixar planilha de exemplo"
                    text="Baixar Exemplo"
                    :on-click="downloadExemplo"/>
              </DxItem>
              <DxItem
                  location="before">
                <div class="btn btn-outline-success btn-sm position-relative overflow-hidden p-2 d-flex gap-2">
                  <i class="bx bx-upload font-size-15"></i> Importar Excel
                  <input type="file" class="position-absolute start-0 top-0 opacity-0" @change="uploadExcel" accept=".xlsx" />
                </div>
              </DxItem>
              <DxItem
                  location="after">
                <DxTextBox
                    placeholder="Pesquisar..."
                    @input="pesquisar"
                    :buttons="[
                        {
                          name: 'iconPesq',
                          location: 'after',
                          options: {
                            icon: 'search',
                            disabled: true,
                            stylingMode: 'text',
                          }
                        }
                    ]"/>
              </DxItem>
            </DxToolbar>
          </div>
        </div>
      </div>
    </div>


    <div v-if="!loading" class="row">
      <ejs-kanban id="kanban" cssClass="kanban-overview"
                  keyField="status"
                  :dataSource="leadsData"
                  :enableTooltip="true"
                  :cardSettings="cardSettings"
                  :swimlaneSettings="swimlaneSettings"
                  :dialogOpen="dialogOpen"
                  :cardRendered='cardRendered'>
        <e-columns>
          <e-column headerText="A Fazer" keyField="AB" :allowToggle="true" :allowDrag="false" :allowDrop="false" :template="columnsTemplate"></e-column>
          <e-column headerText="Em Progresso" keyField="EP" :allowToggle="true" :allowDrag="false" :allowDrop="false" :template="columnsTemplate"></e-column>
          <e-column headerText="Revisão" keyField="RV" :allowToggle="true" :allowDrag="false" :allowDrop="false" :template="columnsTemplate"></e-column>
          <e-column headerText="Fechado" keyField="FC" :allowToggle="true" :allowDrag="false" :allowDrop="false" :template="columnsTemplate"></e-column>
        </e-columns>
      </ejs-kanban>
    </div>

    <b-modal :title="leadData.id != null ? `Editar Lead - ${ leadData.nome } (${ leadData.id })` : 'Criar Novo Lead'"
             size="xl"
             v-model="showModalLead"
             hide-footer
             @hidden="resetModalState">

      <div class="card">
        <div class="card-body">

          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-1
                 class="text-dark"
                 href="javascript: void(0);">
                Detalhes do Lead
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-1" v-model="visibleLead" accordion="my-accordion-1" role="tabpanel">
            <b-card-body>

              <div class="row">

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="acomp">Responsável</label>
                    <input
                        id="acomp"
                        v-model="leadData.acomp"
                        type="text"
                        class="form-control"
                        placeholder="Responsável"
                        :class="{'is-invalid': submittedLead && !leadData.acomp}"/>
                    <div v-if="submittedLead && !leadData.acomp" class="invalid-feedback">
                      <span>Campo Responsável obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="statuslead">Definir Status</label>
                    <select
                        id="statuslead"
                        v-model="leadData.status"
                        class="form-control"
                        :class="{'is-invalid': submittedLead && !leadData.status}">
                      <option value="AB">A Fazer (AB)</option>
                      <option value="EP">Em Progresso (EP)</option>
                      <option value="RV">Revisão (RV)</option>
                      <option value="FC">Fechado (FC)</option>
                    </select>
                    <div v-if="submittedLead && !leadData.status" class="invalid-feedback">
                      <span>Campo status obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-sm-3">
                  <div class="mb-3">
                    <label for="prioridade">Definir Prioridade</label>
                    <select
                        id="prioridade"
                        v-model="leadData.prior"
                        class="form-control"
                        :class="{'is-invalid': submittedLead && !leadData.prior}">
                      <option value="BX">Baixa (BX)</option>
                      <option value="NM">Normal (NM)</option>
                      <option value="AT">Alta (AT)</option>
                      <option value="CR">Crítica (CR)</option>
                    </select>
                    <div v-if="submittedLead && !leadData.prior" class="invalid-feedback">
                      <span>Campo prioridade obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="pontos">Pontos</label>
                    <input
                        id="pontos"
                        v-model="leadData.pontos"
                        type="number"
                        class="form-control text-end"
                        placeholder="Pontos"/>
                  </div>
                </div>

              </div>

              <div class="row">

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="tags">Tag's</label>
                    <input
                        id="tags"
                        v-model="leadData.tags"
                        type="text"
                        class="form-control"
                        placeholder="Tag's"/>
                  </div>
                </div>

                <div class="col-md-12">
                  <div class="mb-3">
                    <label for="resumo">Resumo</label>
                    <textarea id="resumo" v-model="leadData.resumo" type="text" rows="2"
                              class="form-control" placeholder="Resumo" />
                  </div>
                </div>

              </div>

            </b-card-body>
          </b-collapse>


          <b-card-header header-tag="header" role="tab" v-if="leadData.id">
            <h6 class="m-0">
              <a v-b-toggle.accordion-3
                 class="text-dark"
                 href="javascript: void(0);">
                Interações
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-3" v-model="visibleInteracoes" accordion="my-accordion-3" role="tabpanel">
            <b-card-body>

              <Loader v-if="loadingInteracs" style="min-height: 100px;">
              </Loader>

              <div v-if="novaInterac">

                <div class="row">

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="contato">Pessoa de Contato</label>
                      <input
                          id="contato"
                          v-model="interacData.contato"
                          type="text"
                          class="form-control"
                          placeholder="Pessoa de Contato">
                    </div>
                  </div>

                  <div class="col-md-6">
                    <div class="mb-3">
                      <label for="cargo">Cargo</label>
                      <input
                          id="cargo"
                          v-model="interacData.cargo"
                          type="text"
                          class="form-control"
                          placeholder="Cargo">
                    </div>
                  </div>

                </div>

                <div class="row">

                  <div class="col-sm-4">
                    <div class="mb-3">
                      <label for="canal">Canal de Contato</label>
                      <select
                          id="canal"
                          v-model="interacData.canal"
                          class="form-control">
                        <option value="TL">Telefone</option>
                        <option value="WZ">Whatsapp</option>
                        <option value="EM">E-mail</option>
                        <option value="VS">Visita</option>
                        <option value="IN">Instagram</option>
                        <option value="LK">Linked-In</option>
                        <option value="FB">Facebook</option>
                        <option value="OT">Outros</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="telefone">Telefone</label>
                      <input
                          id="telefone"
                          v-model="interacData.telefone"
                          type="text"
                          class="form-control"
                          placeholder="Telefone">
                    </div>
                  </div>

                  <div class="col-md-4">
                    <div class="mb-3">
                      <label for="email">E-mail</label>
                      <input
                          id="email"
                          v-model="interacData.email"
                          type="text"
                          class="form-control"
                          placeholder="E-mail">
                    </div>
                  </div>

                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label for="obs">Observações</label>
                      <textarea id="obs" v-model="interacData.obs" type="text" rows="3"
                                class="form-control" placeholder="Observações" />
                    </div>
                  </div>
                </div>

                <div class="row">
                  <div class="col-md-12">
                    <div class="mb-3">
                      <label for="nota">Nota Interna</label>
                      <p class="text-muted small">Os seguintes campos são de interação: contato, cargo, canal, telefone, email e observações.</p>
                    </div>
                  </div>
                </div>

                <div class="row">

                  <b-button type="button" variant="outline-success" class="ms-1" @click="confInterac">
                    <i class="bx bx-save font-size-16 align-middle me-2"></i>
                    Confirmar Interação
                  </b-button>

                </div>

              </div>

              <div class="row mt-4">
                <div class="table-responsive" style="max-height: 500px; overflow-y: auto;">
                  <table class="table align-middle table-nowrap" v-if="interacsData">
                    <thead class="table-light" style="position: sticky; top: 0; z-index: 10;">
                    <tr>
                      <th class="align-middle" style="min-width: 50px;">ID</th>
                      <th class="align-middle" style="min-width: 150px;">Contato</th>
                      <th class="align-middle" style="min-width: 120px;">Cargo</th>
                      <th class="align-middle" style="min-width: 80px;">Canal</th>
                      <th class="align-middle" style="min-width: 180px;">Data</th>
                      <th class="align-middle" style="min-width: 250px;">Observações</th>
                      <th class="align-middle text-end" style="min-width: 100px;">Ações</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="data in interacsData" :key="data.id">
                      <td>{{ data.id }} </td>
                      <td>{{ data.contato || '-' }} </td>
                      <td>{{ data.cargo || '-' }} </td>
                      <td>{{ data.canal || '-' }} </td>
                      <td>{{ formatDateTime(data.created_at) }} </td>
                      <td class="text-wrap">{{ data.obs || '-' }} </td>
                      <td class="text-end">
                        <div class="button-items">
                          <b-button variant="outline-success" @click="editarInterac(data)">
                            <i class="mdi mdi-pencil d-block font-size-16"></i>
                          </b-button>
                          <b-button variant="outline-danger" @click="deletarInterac(data.id)">
                            <i class="mdi mdi-trash-can d-block font-size-16"></i>
                          </b-button>
                        </div>
                      </td>
                    </tr>
                    </tbody>
                  </table>
                </div>

              </div>

            </b-card-body>
          </b-collapse>

          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-2
                 class="text-dark"
                 href="javascript: void(0);">
                Detalhes do Cliente
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-2" v-model="visibleCliente" accordion="my-accordion-2" role="tabpanel">
            <b-card-body>

              <div class="row">

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="cnpj">CNPJ</label>
                    <input
                        id="cnpj"
                        v-model="leadData.cnpj"
                        type="text"
                        :disabled="leadData.id"
                        class="form-control"
                        :class="{'is-invalid': submittedLead && !leadData.cnpj}"
                        placeholder="CNPJ"/>
                    <div v-if="submittedLead && !leadData.cnpj" class="invalid-feedback">
                      <span>Campo CNPJ obrigatório, favor preencher.</span>
                    </div>
                    <b-button
                        v-if="!leadData.id"
                        variant="outline-primary"
                        size="sm"
                        class="mt-2 w-100"
                        @click="buscarDadosPessoa"
                        :disabled="!leadData.cnpj || loading">
                      <i class="bx bx-search-alt font-size-14 me-1"></i>
                      Buscar da lista pessoas
                    </b-button>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="nome">Nome</label>
                    <input
                        id="nome"
                        v-model="leadData.nome"
                        type="text"
                        class="form-control"
                        :class="{'is-invalid': submittedLead && !leadData.nome}"
                        placeholder="Nome"/>
                    <div v-if="submittedLead && !leadData.nome" class="invalid-feedback">
                      <span>Campo Nome obrigatório, favor preencher.</span>
                    </div>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="fantasia">Nome Fantasia</label>
                    <input
                        id="fantasia"
                        v-model="leadData.fantasia"
                        type="text"
                        class="form-control"
                        placeholder="Nome Fantasia"/>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="endereco">Endereço</label>
                    <input
                        id="endereco"
                        v-model="leadData.endereco"
                        type="text"
                        class="form-control"
                        placeholder="Endereço"/>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="bairro">Bairro</label>
                    <input
                        id="bairro"
                        v-model="leadData.bairro"
                        type="text"
                        class="form-control"
                        placeholder="Bairro"/>
                  </div>
                </div>

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="cidade">Cidade</label>
                    <input
                        id="cidade"
                        v-model="leadData.cidade"
                        type="text"
                        class="form-control"
                        placeholder="Cidade"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="estado">Estado</label>
                    <input
                        id="estado"
                        v-model="leadData.estado"
                        type="text"
                        class="form-control"
                        placeholder="Estado"/>
                  </div>
                </div>

              </div>

              <div class="row">

                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="email">E-mail</label>
                    <input
                        id="email"
                        v-model="leadData.email"
                        type="text"
                        class="form-control"
                        placeholder="E-mail"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="telefone_1">Telefone 1</label>
                    <input
                        id="telefone_1"
                        v-model="leadData.tel1"
                        type="text"
                        class="form-control"
                        placeholder="Telefone 1"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="telefone_2">Telefone 2</label>
                    <input
                        id="telefone_2"
                        v-model="leadData.tel2"
                        type="text"
                        class="form-control"
                        placeholder="Telefone 2"/>
                  </div>
                </div>

                <div class="col-md-2">
                  <div class="mb-3">
                    <label for="telefone_3">Telefone 3</label>
                    <input
                        id="telefone_2"
                        v-model="leadData.tel3"
                        type="text"
                        class="form-control"
                        placeholder="Telefone 3"/>
                  </div>
                </div>

              </div>

            </b-card-body>
          </b-collapse>


          <b-card-header header-tag="header" role="tab">
            <h6 class="m-0">
              <a v-b-toggle.accordion-4
                 class="text-dark"
                 href="javascript: void(0);">
                Mais Informações
              </a>
            </h6>
          </b-card-header>
          <b-collapse id="accordion-4" accordion="my-accordion-2" role="tabpanel">
            <b-card-body>

              <div class="row">

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="created_at">Data</label>
                    <input
                        id="created_at"
                        v-model="leadData.created_at"
                        type="text"
                        class="form-control"
                        :disabled="true"
                        placeholder="Data"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="updated_at">Alteração</label>
                    <input
                        id="updated_at"
                        v-model="leadData.updated_at"
                        type="text"
                        class="form-control"
                        :disabled="true"
                        placeholder="Alteração"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="coleta">Coleta</label>
                    <input
                        id="coleta"
                        v-model="leadData.coleta"
                        type="text"
                        class="form-control"
                        :disabled="true"
                        placeholder="Coleta"/>
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="mb-3">
                    <label for="created_by">Criação</label>
                    <input
                        id="created_by"
                        v-model="leadData.created_by"
                        type="text"
                        class="form-control"
                        :disabled="true"
                        placeholder="Criação"/>
                  </div>
                </div>

              </div>

            </b-card-body>
          </b-collapse>

        </div>
      </div>


      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalLead = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Fechar
        </b-button>
        <b-button variant="outline-danger" class="ms-1" @click="deletaLead" v-if="leadData.id">
          <i class="bx bx-trash font-size-16 align-middle me-2"></i>
          Excluir Lead
        </b-button>

        <b-button variant="outline-info" class="ms-1" @click="novaInteracao" v-if="leadData.id">
          <i class="bx bx-plus-circle font-size-16 align-middle me-2"></i>
          Nova Interação
        </b-button>

        <b-button type="submit" variant="success" class="ms-1" @click="confLead">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal title="Período de Exibição" v-model="showModalPeriodo" centered hide-footer>
      <div class="col-md-12">
        <div class="mb-3">
          <label for="perexib">Selecionar Data Inicial e Final</label>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtIniFiltro">Data Início</label>
            <input
                id="dtIniFiltro"
                v-model="dtIniFiltro"
                type="date"
                class="form-control"
                placeholder="Data Início"
                :class="{'is-invalid': submittedPeriodo && !dtIniFiltro,}"/>
            <div v-if="submittedPeriodo && !dtIniFiltro"
                 class="invalid-feedback">
              <span >Campo data início obrigatório, favor preencher.</span>
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="mb-3">
            <label for="dtFimFiltro">Data Final</label>
            <input
                id="dtFimFiltro"
                v-model="dtFimFiltro"
                type="date"
                class="form-control"
                placeholder="Data Final"
                :class="{'is-invalid': submittedPeriodo && !dtFimFiltro,}"/>
            <div v-if="submittedPeriodo && !dtFimFiltro"
                 class="invalid-feedback">
              <span >Campo data final obrigatória, favor preencher.</span>
            </div>
          </div>
        </div>
      </div>
      <b-alert v-if="this.erroPeriodo !== ''"  show dismissible variant="danger" >
        <i class="mdi mdi-alert me-2"></i> {{ erroPeriodo }}
      </b-alert>
      <div class="text-end mt-5">
        <b-button variant="light" @click="showModalPeriodo = false">
          <i class="bx bx-block font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button type="submit" variant="success" class="ms-1" @click="confirmarPeriodo">
          <i class="bx bx-check-double font-size-16 align-middle me-2"></i>
          Confirmar
        </b-button>
      </div>
    </b-modal>

    <b-modal
      title="Importando Planilha"
      v-model="showModalUpload"
      centered
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      hide-header-close>
      <div class="text-center p-4">
        <div class="spinner-border text-primary mb-3" role="status" style="width: 3rem; height: 3rem;">
          <span class="visually-hidden">Carregando...</span>
        </div>
        <h5 class="mb-3">{{ uploadProgress }}</h5>
        <b-alert show variant="warning" class="mt-3">
          <i class="mdi mdi-alert me-2"></i>
          <strong>ATENÇÃO!</strong> Não recarregue ou feche esta página até que a importação seja concluída.
          <br>Se a página for recarregada ou fechada antes de todos os itens serem enviados, eles ficarão de fora!
        </b-alert>
      </div>
    </b-modal>

    <b-modal
      title="Confirmar Importação"
      v-model="showModalConfirmUpload"
      centered
      hide-footer>
      <div class="p-3">
        <b-alert show variant="warning" class="mb-4">
          <div class="d-flex align-items-center mb-3">
            <i class="mdi mdi-alert-circle font-size-24 me-3"></i>
            <h5 class="mb-0">ATENÇÃO!</h5>
          </div>
          <p class="mb-2">
            <strong>Cuidado ao importar a planilha!</strong>
          </p>
          <p class="mb-0">
            Caso os CNPJs informados <strong>não sejam encontrados</strong> no sistema,
            <strong class="text-danger">novos registros de leads serão criados automaticamente</strong>.
          </p>
        </b-alert>

        <div class="text-muted mb-3">
          <i class="mdi mdi-information-outline me-2"></i>
          Certifique-se de que os dados da planilha estão corretos antes de prosseguir.
        </div>
      </div>

      <div class="text-end mt-4 px-3 pb-3">
        <b-button variant="light" @click="cancelarUpload">
          <i class="bx bx-x font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button variant="success" class="ms-2" @click="confirmarUpload">
          <i class="bx bx-check font-size-16 align-middle me-2"></i>
          Confirmar Importação
        </b-button>
      </div>
    </b-modal>

    <b-modal
      title="Instruções para Importação"
      v-model="showModalInstrucoes"
      centered
      size="lg"
      hide-footer>
      <div class="p-3">
        <b-alert show variant="info" class="mb-4">
          <div class="d-flex align-items-center mb-3">
            <i class="mdi mdi-information font-size-24 me-3"></i>
            <h5 class="mb-0">Instruções Importantes</h5>
          </div>
          <p class="mb-2">
            Leia atentamente as instruções abaixo antes de preencher a planilha:
          </p>
        </b-alert>

        <div class="mb-4">
          <div class="d-flex align-items-start mb-3">
            <div class="flex-shrink-0">
              <div class="avatar-sm">
                <span class="avatar-title rounded-circle bg-primary text-white font-size-16">
                  1
                </span>
              </div>
            </div>
            <div class="flex-grow-1 ms-3">
              <h6 class="mb-2">Validação de CNPJs</h6>
              <p class="text-muted mb-0">
                Ao cadastrar interações, <strong>confirme se os CNPJs condizem com os CNPJs já cadastrados</strong>.
                Caso estejam diferentes, <strong class="text-danger">um novo lead será gerado</strong> com essas novas informações.
              </p>
            </div>
          </div>

          <div class="d-flex align-items-start mb-3">
            <div class="flex-shrink-0">
              <div class="avatar-sm">
                <span class="avatar-title rounded-circle bg-primary text-white font-size-16">
                  2
                </span>
              </div>
            </div>
            <div class="flex-grow-1 ms-3">
              <h6 class="mb-2">Cadastro Apenas de Interação</h6>
              <p class="text-muted mb-0">
                Caso esteja <strong>apenas cadastrando informações de interação</strong> e não um novo lead,
                não é necessário inserir outras informações do Lead além do <strong>CNPJ</strong>.
              </p>
            </div>
          </div>

          <div class="d-flex align-items-start">
            <div class="flex-shrink-0">
              <div class="avatar-sm">
                <span class="avatar-title rounded-circle bg-primary text-white font-size-16">
                  3
                </span>
              </div>
            </div>
            <div class="flex-grow-1 ms-3">
              <h6 class="mb-2">Edição Posterior</h6>
              <p class="text-muted mb-0">
                Após importar a planilha, <strong>todas as informações ainda podem ser editadas posteriormente</strong>
                através da interface do sistema.
              </p>
            </div>
          </div>
        </div>

        <b-alert show variant="success" class="mb-0">
          <i class="mdi mdi-check-circle me-2"></i>
          <strong>Dica:</strong> Utilize o exemplo da planilha como referência para preencher corretamente todos os campos.
        </b-alert>
      </div>

      <div class="text-end mt-4 px-3 pb-3">
        <b-button variant="light" @click="showModalInstrucoes = false">
          <i class="bx bx-x font-size-16 align-middle me-2"></i>
          Cancelar
        </b-button>
        <b-button variant="primary" class="ms-2" @click="confirmarDownload">
          <i class="bx bx-download font-size-16 align-middle me-2"></i>
          Baixar Planilha Exemplo
        </b-button>
      </div>
    </b-modal>

  </Layout>
</template>


<style>
.kanban-overview.e-kanban .header-template-wrap {
  display: inline-flex;
  font-size: 15px;
  font-weight: 500;
}

.kanban-overview.e-kanban .header-template-wrap .header-icon {
  font-family: "Kanban priority icons";
  margin-top: 3px;
  width: 10%;
}

.kanban-overview.e-kanban .header-template-wrap .header-text {
  margin-left: 15px;
}

.kanban-overview.e-kanban.e-rtl .header-template-wrap .header-text {
  margin-right: 15px;
}

.kanban-overview.e-kanban.e-rtl .e-card-avatar {
  left: 12px;
  right: auto;
}

.kanban-overview.e-kanban .e-card-avatar {
  width: 30px;
  height: 30px;
  text-align: center;
  background-color: gainsboro;
  color: #323232;
  border-radius: 50%;
  position: absolute;
  right: 12px;
  bottom: 10px;
  font-size: 12px;
  font-weight: 400;
  padding: 10px 0px 0px 1px;
}

.kanban-overview.e-kanban .AB::before {
  content: "\e700";
  color: #0251cc;
  font-size: 16px;
}

.kanban-overview.e-kanban .EP::before {
  content: "\e703";
  color: #ea9713;
  font-size: 16px;
}

.kanban-overview.e-kanban .e-image img {
  background: #ececec;
  border: 1px solid #c8c8c8;
  border-radius: 50%;
}

.kanban-overview.e-kanban .RV::before {
  content: "\e701";
  color: #8e4399;
  font-size: 16px;
}

.kanban-overview.e-kanban .FC::before {
  content: "\e702";
  color: #63ba3c;
  font-size: 16px;
}

.kanban-overview.e-kanban .e-card .e-card-tag-field {
  background: #ececec;
  color: #6b6b6b;
  margin-right: 5px;
  line-height: 1.1;
  font-size: 13px;
  border-radius: 3px;
  padding: 4px;
}

.kanban-overview.e-kanban .e-card-custom-footer {
  display: flex;
  padding: 0px 12px 12px;
  line-height: 1;
  height: 35px;
}

.kanban-overview.e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card.BX.e-selection:hover,
.kanban-overview.e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card.BX,
.kanban-overview.e-kanban.e-rtl .e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card.BX {
  border-left: 3px solid #1F88E5;
}

.kanban-overview.e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card.AT.e-selection:hover,
.kanban-overview.e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card.AT,
.kanban-overview.e-kanban.e-rtl .e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card.AT {
  border-left: 3px solid #673AB8;
}

.kanban-overview.e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card.NM.e-selection:hover,
.kanban-overview.e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card.NM,
.kanban-overview.e-kanban.e-rtl .e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card.NM {
  border-left: 3px solid #02897B;
}

.kanban-overview.e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card.CR.e-selection:hover,
.kanban-overview.e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card.CR,
.kanban-overview.e-kanban.e-rtl .e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card.CR {
  border-left: 3px solid #E64A19;
}

.kanban-overview.e-kanban.e-rtl .e-kanban .e-kanban-content .e-content-row .e-content-cells .e-card-wrapper .e-card {
  border-left: none
}

@font-face {
  font-family: "Kanban priority icons";
  src: url(data:application/x-font-ttf;charset=utf-8;base64,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)
  format("truetype");
  font-weight: normal;
  font-style: normal;
}

[class^="sf-icon-"],
[class*=" sf-icon-"] {
  font-family: "Kanban priority icons" !important;
  speak: none;
  font-size: 55px;
  font-style: normal;
  font-weight: normal;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

</style>